"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrainModelSubspace = void 0;
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
var tag_typescript_client_1 = require("@tableau/tag-typescript-client");
var widgets_1 = require("@tableau/widgets");
var React = require("react");
var Localize_1 = require("../../gen-src/Localize");
var TagHelpers_1 = require("../Tag/TagHelpers");
var TestIds_1 = require("../util/TestIds");
var Utils_1 = require("../util/Utils");
var ProgressStatus = /** @class */ (function () {
    function ProgressStatus(previousUpdates) {
        this.previousUpdates = [];
        this.trainingPhase = Utils_1.TrainingPhase.Undefined;
        this.previousUpdates = previousUpdates;
        for (var i = this.previousUpdates.length - 1; i >= 0; i--) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            if (previousUpdates[i] === tag_typescript_client_1.TableauPredictivemodelcontrollerV1GetTrainingStatusResponseStatusEnum.Success) {
                this.trainingPhase = Utils_1.TrainingPhase.Complete;
                break;
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            }
            else if (previousUpdates[i] === tag_typescript_client_1.TableauPredictivemodelcontrollerV1GetTrainingStatusResponseStatusEnum.Preprocessing) {
                this.trainingPhase = Utils_1.TrainingPhase.DescriptiveAnalysis;
                break;
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            }
            else if (previousUpdates[i] === tag_typescript_client_1.TableauPredictivemodelcontrollerV1GetTrainingStatusResponseStatusEnum.RunningPredictive) {
                this.trainingPhase = Utils_1.TrainingPhase.ModelCreation;
                break;
            }
            else {
                this.trainingPhase = Utils_1.TrainingPhase.DataMovement;
            }
        }
    }
    ProgressStatus.prototype.isInProcessing = function () {
        return this.trainingPhase === Utils_1.TrainingPhase.Undefined || this.trainingPhase === Utils_1.TrainingPhase.Processing;
    };
    ProgressStatus.prototype.isInDataMovement = function () {
        return this.trainingPhase === Utils_1.TrainingPhase.DataMovement;
    };
    ProgressStatus.prototype.isInDescriptiveAnalysis = function () {
        return this.trainingPhase === Utils_1.TrainingPhase.DescriptiveAnalysis;
    };
    ProgressStatus.prototype.isInModelCreation = function () {
        return this.trainingPhase === Utils_1.TrainingPhase.ModelCreation;
    };
    ProgressStatus.prototype.isProcessingComplete = function () {
        return this.trainingPhase > Utils_1.TrainingPhase.Processing;
    };
    ProgressStatus.prototype.isDataMovementComplete = function () {
        return this.trainingPhase > Utils_1.TrainingPhase.DataMovement;
    };
    ProgressStatus.prototype.isDescriptiveAnalysisComplete = function () {
        return this.trainingPhase > Utils_1.TrainingPhase.DescriptiveAnalysis;
    };
    ProgressStatus.prototype.isModelCreationComplete = function () {
        return this.trainingPhase > Utils_1.TrainingPhase.ModelCreation;
    };
    ProgressStatus.prototype.isAllComplete = function () {
        return this.trainingPhase === Utils_1.TrainingPhase.Complete;
    };
    ProgressStatus.prototype.completeTitle = function () {
        if (this.isAllComplete()) {
            return '✓';
        }
        return '-';
    };
    return ProgressStatus;
}());
var ProgressIndicatorPhase = function (props) {
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { style: { display: 'flex', flexDirection: 'column', alignItems: 'left', justifyContent: 'flex-start' } },
            React.createElement("div", { style: { height: '50px', display: 'flex', alignItems: 'center', justifyContent: 'flex-start' } },
                props.animate && (React.createElement("img", { src: "data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9JzMwMHB4JyB3aWR0aD0nMzAwcHgnICBmaWxsPSIjMDAwMDAwIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2ZXJzaW9uPSIxLjEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAwIDAgNTEyIDUxMiIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+PHBhdGggZD0iTTQ0My41LDIxOC41di0xNTBsLTU0LjksNTQuOUMzNTQuNiw4OS41LDMwNy44LDY4LjUsMjU2LDY4LjVjLTEwMy41LDAtMTg3LjUsODQtMTg3LjUsMTg3LjVjMCwxMDMuNSw4NCwxODcuNSwxODcuNSwxODcuNSAgYzEwMy41LDAsMTg3LjUtODQsMTg3LjUtMTg3LjVINDA2YzAsODIuNy02Ny4zLDE1MC0xNTAsMTUwYy04Mi43LDAtMTUwLTY3LjMtMTUwLTE1MHM2Ny4zLTE1MCwxNTAtMTUwYzQxLjQsMCw3OC45LDE2LjksMTA1LjksNDQuMSAgbC02OC40LDY4LjRINDQzLjV6Ij48L3BhdGg+PC9zdmc+", alt: "", style: { display: 'absolute', width: '32px', height: '32px', animation: 'rotation 8s infinite linear' } })),
                !props.animate && (React.createElement("div", { style: { width: '16px', height: '16px', borderRadius: 8, backgroundColor: props.complete ? '#42c257' : '#aaa' } })),
                !props.hideComplete && React.createElement("div", { style: { width: '200px', height: '4px', backgroundColor: props.complete ? '#42c257' : '#aaa' } })),
            React.createElement("div", { style: { fontSize: 18, color: '#a0a0a0' } }, props.title))));
};
var ProgressIndicator = function (props) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    var code = props.status.previousUpdates.length > 0 ? props.status.previousUpdates.slice(-1)[0] : '';
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { style: { width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' } },
            React.createElement(ProgressIndicatorPhase, { complete: props.status.isProcessingComplete(), animate: props.status.isInProcessing(), title: 'Processing' }),
            React.createElement(ProgressIndicatorPhase, { complete: props.status.isDataMovementComplete(), animate: props.status.isInDataMovement(), title: 'Data Movement' }),
            React.createElement(ProgressIndicatorPhase, { complete: props.status.isDescriptiveAnalysisComplete(), animate: props.status.isInDescriptiveAnalysis(), title: 'Descriptive Analysis' }),
            React.createElement(ProgressIndicatorPhase, { complete: props.status.isModelCreationComplete(), animate: props.status.isInModelCreation(), title: 'Model Creation' }),
            React.createElement(ProgressIndicatorPhase, { complete: props.status.isAllComplete(), title: props.status.completeTitle(), hideComplete: true })),
        React.createElement("div", { style: { paddingTop: '100px' } }, code)));
};
var getOutcome = function (objective) {
    if (objective.outcomeType === 'Text') {
        var outcome_1 = {
            goal: objective.goal,
            name: objective.outcomeField,
            type: objective.outcomeType,
            successValue: objective.successValue,
            failureValue: objective.failureValue,
        };
        return outcome_1;
    }
    var outcome = {
        goal: objective.goal,
        name: objective.outcomeField,
        type: objective.outcomeType,
    };
    return outcome;
};
var getModelConfiguration = function (objective) {
    var modelConfiguration = {
        modelAlgType: objective.algorithm,
    };
    return modelConfiguration;
};
var getStartTrainingModelRequest = function (props) {
    var startTrainingRequest = {
        label: 'test',
        folderId: '005B0000006wvarIAA',
        dataSetId: props.objective.dataSourceId,
        dataVersionId: props.objective.dataSourceVersionId,
        type: 'AnalyticsDataset',
        outcome: getOutcome(props.objective),
        modelConfiguration: getModelConfiguration(props.objective),
        autoPilotEnabled: false,
    };
    return startTrainingRequest;
};
var TrainModelSubspace = function (props) {
    var _a = React.useState({ storyId: '', runId: '', started: false }), trainingContext = _a[0], setTrainingContext = _a[1];
    var _b = React.useState(new ProgressStatus([])), trainingStatus = _b[0], setTrainingStatus = _b[1];
    var callStartTraining = function () {
        if (trainingContext.storyId) {
            trainingContext.started = false;
            return;
        }
        TagHelpers_1.StartTraining(getStartTrainingModelRequest(props)).then(function (response) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            setTrainingContext({ storyId: response.storyId || '', runId: response.runId || '', started: true });
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            if (response.storyId !== undefined) {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                callGetStatus(response.storyId || '', response.runId || '');
                props.setPredictiveModelContent({
                    storyId: response.storyId ? response.storyId : '',
                    runId: response.runId ? response.runId : '',
                });
            }
        }, function (reason) {
            console.log(reason);
        });
    };
    var callGetStatus = function (storyId, runId) {
        TagHelpers_1.GetTrainingStatus({
            storyId: storyId,
            runId: runId,
        }).then(function (response) {
            var previousUpdates = trainingStatus.previousUpdates;
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            if (response.status !== undefined) {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                previousUpdates.push(response.status);
            }
            setTrainingStatus(new ProgressStatus(previousUpdates));
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            if (response.status !== tag_typescript_client_1.TableauPredictivemodelcontrollerV1GetTrainingStatusResponseStatusEnum.Success) {
                setTimeout(function () {
                    callGetStatus(storyId, runId);
                }, 500);
            }
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            if (response.status === tag_typescript_client_1.TableauPredictivemodelcontrollerV1GetTrainingStatusResponseStatusEnum.Success) {
                callGetTrainingResults(storyId, runId);
                props.setModelStatus(Utils_1.ModelStatus.Trained);
                props.setSubspace(Utils_1.SubspaceType.Results);
            }
        }, function (reason) {
            console.log(reason);
        });
    };
    var callGetTrainingResults = function (storyId, runId) {
        TagHelpers_1.GetTrainingResults({
            storyId: storyId,
            runId: runId,
        }).then(function (response) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            props.setModelResult(response.validation || '');
        }, function (reason) {
            console.log(reason);
        });
    };
    return (React.createElement("div", null,
        trainingContext.storyId && trainingContext.started && (React.createElement("div", { style: { padding: '100px' } },
            React.createElement(ProgressIndicator, { status: trainingStatus }),
            React.createElement("a", { href: 'https://gs0.lightning.force.com/analytics/story/' + trainingContext.storyId },
                "https://gs0.lightning.force.com/analytics/story/",
                trainingContext.storyId))),
        !trainingContext.storyId && trainingContext.started && (React.createElement("div", { style: { width: '100%', height: '400px', display: 'flex', alignItems: 'center', justifyContent: 'center' } },
            React.createElement("img", { src: "data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9JzMwMHB4JyB3aWR0aD0nMzAwcHgnICBmaWxsPSIjMDAwMDAwIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2ZXJzaW9uPSIxLjEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAwIDAgNTEyIDUxMiIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+PHBhdGggZD0iTTQ0My41LDIxOC41di0xNTBsLTU0LjksNTQuOUMzNTQuNiw4OS41LDMwNy44LDY4LjUsMjU2LDY4LjVjLTEwMy41LDAtMTg3LjUsODQtMTg3LjUsMTg3LjVjMCwxMDMuNSw4NCwxODcuNSwxODcuNSwxODcuNSAgYzEwMy41LDAsMTg3LjUtODQsMTg3LjUtMTg3LjVINDA2YzAsODIuNy02Ny4zLDE1MC0xNTAsMTUwYy04Mi43LDAtMTUwLTY3LjMtMTUwLTE1MHM2Ny4zLTE1MCwxNTAtMTUwYzQxLjQsMCw3OC45LDE2LjksMTA1LjksNDQuMSAgbC02OC40LDY4LjRINDQzLjV6Ij48L3BhdGg+PC9zdmc+", alt: "", style: { display: 'absolute', width: '64px', height: '64px', animation: 'rotation 8s infinite linear' } }))),
        !trainingContext.started && (React.createElement("div", { style: { width: '100%', height: '400px', display: 'flex', alignItems: 'center', justifyContent: 'center' } },
            React.createElement(widgets_1.ButtonWidget, { onClick: function () { return callStartTraining(); }, testId: TestIds_1.START_TRAINING_BUTTON_TEST_ID, buttonType: widgets_1.ButtonType.Primary }, Localize_1.Messages.startTrainingButton())))));
};
exports.TrainModelSubspace = TrainModelSubspace;
//# sourceMappingURL=TrainModelSubspace.js.map